import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { TimeOutMessageComponent } from '../time-out-message.component';

@Component({
    selector: 'app-idle',
    templateUrl: './app-idle.component.html',
    styleUrls: ['./app-idle.component.css'],
    standalone: false
})
export class AppIdleComponent implements OnInit, OnDestroy {
	onIdleEnd$: Subscription;
	onTimeout$: Subscription;
	onIdleStart$: Subscription;
	onLogout$: Subscription;

	constructor(
		private idle: Idle,
		private snackBar: MatSnackBar,
		private cmnServ: CommonService,
		private router: Router
	) {
		// START ********** handling token timeout  *********
		//idle behavior: if idle for 3 hours, show timeout count down message for 2 min.
		// If no action detected in straight 3 hours 2 mins (182 mins), redirect to the session timeout page.
		// idle timeout is the time until idle countdown in seconds
		idle.setIdle(3 * 60 * 60);
		// timeout is the countdown time in seconds
		idle.setTimeout(120);
		// sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
		idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

		// idle interrupted
		this.onIdleEnd$ = idle.onIdleEnd.subscribe(() => {
			this.snackBar.dismiss();
		});
		// idle time out
		this.onTimeout$ = idle.onTimeout.subscribe(() => {
			localStorage.clear();
			sessionStorage.clear();
			this.snackBar.dismiss();
			this.router.navigateByUrl('/');
			this.cmnServ.onLogout.next(true);
		});
		// triggers when countdown starts
		this.onIdleStart$ = idle.onIdleStart.subscribe(() => {
			this.snackBar.openFromComponent(TimeOutMessageComponent);
		});

		// Listen for logout events to stop the idle timer
		this.onLogout$ = this.cmnServ.onLogout.subscribe((loggedOut) => {
			if (loggedOut) {
				this.stopIdleTimer();
			}
		});

		this.idle.watch();
		// END ********** handling token timeout  *********
	}

	ngOnInit() {}

	/**
	 * @description stops the idle timer and cleans up subscriptions
	 */
	private stopIdleTimer(): void {
		this.idle.stop();
		this.snackBar.dismiss();
	}

	/**
	 * @description unsubscribe to observable
	 */
	ngOnDestroy(): void {
		this.stopIdleTimer();
		
		if (this.onTimeout$) {
			this.onTimeout$.unsubscribe();
		}
		if (this.onIdleEnd$) {
			this.onIdleEnd$.unsubscribe();
		}
		if (this.onIdleStart$) {
			this.onIdleStart$.unsubscribe();
		}
		if (this.onLogout$) {
			this.onLogout$.unsubscribe();
		}
	}
}
